module.exports = __webpack_public_path__ + "img/firstNameEle.d5c497c9.svg";